export default __webpack_public_path__ + "static/media/foodbank_icon.d50c54a5.png";